import Raven from 'raven-js';
import identity from 'transmute/identity';
import { evaluateProposedRulesRpc } from '../../../__generated__/chirp/com/hubspot/property/validation/rpc/PropertyValidationRpc';
import { InMemoryCache } from '../InMemoryCache';
const VALID_EMAIL = {
  isValid: true,
  error: null,
  message: null
};
const fetchValidateEmailChirp = (email, rpcClient) => {
  return rpcClient.call(evaluateProposedRulesRpc, {
    request: {
      proposedRules: [{
        ruleType: 'EMAIL',
        ruleArguments: []
      }],
      proposedValue: email
    }
  }).then(response => {
    var _response$validationR;
    const first = (_response$validationR = response.validationResults) === null || _response$validationR === void 0 ? void 0 : _response$validationR[0];
    if (!first) {
      return VALID_EMAIL;
    }
    return {
      isValid: first.isValid,
      error: typeof first.error === 'string' && first.error !== 'NO_ERROR' ? first.error : null,
      message: first.message || null
    };
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        email
      }
    });
  });
};
export const makeEmailValidationCache = () => new InMemoryCache('EmailValidationCache', identity, ({
  rpcClient
}) => email => fetchValidateEmailChirp(email, rpcClient));